import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, verifySession } from '../utils/api';

export const RequireAuth = ({ children, requireAdmin = false }) => {
  const location = useLocation();
  const [status, setStatus] = useState(isAuthenticated() ? 'checking' : 'denied');

  useEffect(() => {
    if (status !== 'checking') return;
    verifySession()
      .then((user) => setStatus(requireAdmin && user?.role !== 'admin' ? 'forbidden' : 'ok'))
      .catch(() => setStatus('denied'));
  }, [status, requireAdmin]);

  if (status === 'denied') {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  if (status === 'forbidden') {
    return <Navigate to="/admin/dashboard" replace />;
  }
  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="auth-checking">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  return children;
};
